module.exports = __webpack_public_path__ + "img/colaboracion.2b7013d9.png";